<template>
    <div>
        <div v-for="(date, i) in dates" v-bind:key="'date-time-'+i" style="margin-bottom: 10px;">
            <div style="position: relative;">
                <div style="width:30%; margin-right: 1%; float:left;">
                    <input type="text" :class="aspect.formFieldClass" v-model="dates[i].date" placeholder="Data (dd-mm-aaaa)">
                </div>
                <div style="width:30%; margin-right: 1%; float:left;">
                    <input type="text" :class="aspect.formFieldClass" v-model="dates[i].start_time" placeholder="Ora inizio (HH:MM)">
                </div>
                <div style="width:30%; margin-right: 1%; float:left;">
                    <input type="text" :class="aspect.formFieldClass" v-model="dates[i].end_time" placeholder="Ora fine (HH:MM)">
                </div>
                <div style="position: absolute; top: 3px; right: 10px; cursor: pointer;" @click="remove(i)"><i class="fa fa-times"></i></div>
                <div style="clear: both;"></div>
            </div>
        </div>
        <button @click="addDates">Aggiungi data</button>
    </div>
</template>

<script>
    export default {
        name: 'form-element-course-multi-date',
        props: {
            value:{type:Array},
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }}
        },
        data(){
            return {
                dates: [],
            }
        },
        watch:{
            dates: {
                deep: true,
                handler(){
                    this.$emit('input', this.dates);
                }
            }
        },
        mounted(){
            if(this.value != null)
                this.dates = this.value
        },
        methods: {
            addDates(e){
                e.preventDefault();
                this.dates.push({ date: null, start_time: "09:00", end_time: "18:00" });
                return false;
            },
            remove(i){
                this.dates.splice(i, 1);
            }
        }
    }
</script>